import { render, staticRenderFns } from "./CreateBusinessCard.vue?vue&type=template&id=5f9e1a51&scoped=true"
import script from "./CreateBusinessCard.vue?vue&type=script&lang=js"
export * from "./CreateBusinessCard.vue?vue&type=script&lang=js"
import style0 from "./CreateBusinessCard.vue?vue&type=style&index=0&id=5f9e1a51&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f9e1a51",
  null
  
)

export default component.exports